import CookieConsentDeclineButton from "./CookieConsentDeclineButton";

export default CookieConsentDeclineButton;
